<template>
    <template v-if="mode === 'table'">
        <div v-if="v!='null'">
            <p v-if="lengthrow!==undefined">{{v}}</p>
            <p v-else class="text-truncate" style="max-width: 300px;">{{v}}</p>
        </div>
</template>
<template v-else-if="mode === 'edit'">
<!-- <v-text-field :label=column.title variant="outlined" v-model="v" @input="handleInput" :name="column.title" :id="column.title"></v-text-field> -->
    <!-- <v-combobox
        variant="outlined"
        :label="column.title"
        :id="column.title"
        v-model="v"
        @input="handleInput"
        @change="saveInput"
        :items="history"
        autocomplete = "off"
    >
    </v-combobox> -->
    <v-combobox
        variant="outlined"
        :label="column.title"
        :id="column.title"
        v-model="v"
        @input="handleInput"
        @change="saveInput"
        :items="history"
        autocomplete = "off"
        @update:modelValue="handleItemClick"
    >
    </v-combobox>

     
</template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiContentSavePlus } from '@mdi/js';

export default {
    name: 'string-widget',
        components: {
      SvgIcon,
  },
    props:['mode','column', 'modelValue','lengthrow'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            mdiContentSavePlus:mdiContentSavePlus,
            //v: this.modelValue,
            v: String(this.modelValue),
//            fieldname: this.column.title,
//            search: this.v,
//            options: [],
//            searchvalue: '',
      history: [],   // Массив для хранения истории
      historyKey: this.column.title, // Ключ для localStorage
      maxHistoryItems: 10, // Максимальное количество записей в истории
        }
    },

        mounted(){
 // При загрузке компонента, загружаем историю из localStorage
    this.loadHistory();
    // Устанавливаем последнее введенное значение, если оно есть
    if (this.history.length > 0) {
      this.v = this.history[0];
    }

//this.fieldname = this.column.title;
//console.log(this.modelValue, this.fieldname);

if (this.modelValue == '' || this.modelValue == undefined || this.modelValue == null || this.modelValue == 'null'||this.modelValue == 'NULL'){
this.v = '';
}
else {
this.v = String(this.modelValue);
}
 /// в детайлсе неправльный тип ппроявляется даже без всяких правок - пустоеполе уходит объектом. Короче - типизировать все виджеты на вхо ди на выход


},

    methods:{
///
    handleItemClick(itemValue) {
        // The `itemValue` argument here is the value of the selected item
        // as determined by the `item-value` prop (or the whole object if `return-object` is used).
        console.log('Item clicked:', itemValue);
        // You can perform further actions here, like calling an API
        // or navigating to a new page.
        this.$emit('update:modelValue', itemValue);
        },
    // Сохраняет введенный текст и обновляет историю
    saveInput() {
      // Добавляем текущий текст в начало истории (если он не пустой)
      if (this.v.trim() !== '') {
        this.history.unshift(this.v);
        // Удаляем старые записи, если их больше чем maxHistoryItems
        if (this.history.length > this.maxHistoryItems) {
          this.history.pop();
        }
        // Сохраняем обновленную историю в localStorage
        localStorage.setItem(this.historyKey, JSON.stringify(this.history));
      }

    //   this.handleInput();

    },
    // Загружает историю из localStorage
    loadHistory() {
      const storedHistory = localStorage.getItem(this.historyKey);
      if (storedHistory) {
        this.history = JSON.parse(storedHistory);
      }
    },

        ///
        handleInput(e) {       
            

        //    this.v = e.target.value;            
        //    this.$emit('update:modelValue', this.v)
//           this.$emit('update:modelValue', e.target.value)
        let choosedvalue = '';
        if (e.target.value == '' || e.target.value == undefined || e.target.value == null){
            choosedvalue = null;
        }  
        else{
            choosedvalue = e.target.value;
//                choosedvalue = null;
        }
//        console.log(choosedvalue, typeof(choosedvalue));
//    choosedvalue = String(choosedvalue);
        console.log(choosedvalue, typeof(choosedvalue));

        this.$emit('update:modelValue', choosedvalue);


        if (choosedvalue == null){
            this.v = '';
        }  
        else{
            this.v = String(this.modelValue);
        }



//        this.v = choosedvalue;

        // если не делать проверку на пустое значение, то поле его отправляет некорректно и "" не записывается на беке.
        // почему-то поле даже просто текст воспринимает пустоту как объект а непустое значение - как строку? 

        },

    },
// test with this variant (another varant - use modelValue directly in template)
watch: {
    modelValue() {
//        this.v = String(this.modelValue);
        if (this.modelValue == null){
            this.v = '';
        }  
        else{
            this.v = String(this.modelValue);
        }



    },

},

}
</script>